import { DataType } from '@bechtel/sr-types';
import { CustomFloatingFilterProps } from 'ag-grid-react';
import { isEmpty, replace } from 'lodash';
import { ChangeEvent, Fragment, useState } from 'react';
import { isInValidSearchValue } from '../utils';

export interface CustomProps extends CustomFloatingFilterProps {
  dataType: DataType;
}
const getOperator = (input, dataType) => {
  if (input.startsWith('=')) {
    return 'equals';
  } else if (input.startsWith('>=') && dataType === DataType.NUMBER) {
    return 'greaterThanOrEqual';
  } else if (input.startsWith('<=') && dataType === DataType.NUMBER) {
    return 'lessThanOrEqual';
  } else if (input.startsWith('!=')) {
    return 'notEqual';
  } else if (input.startsWith('<>')) {
    return 'notEqual';
  } else if (input.startsWith('>') && dataType === DataType.NUMBER) {
    return 'greaterThan';
  } else if (input.startsWith('<') && dataType === DataType.NUMBER) {
    return 'lessThan';
  }
  return dataType === DataType.NUMBER ? 'equals' : 'contains';
};

export const FloatingFilter = ({ onModelChange, dataType, api, column }: CustomProps) => {
  const filterModel = api.getFilterModel();
  const colfilter = filterModel[column.getColId()]?.filterModels || [];
  const [value, setValue] = useState(colfilter[0]?.filter ?? '');

  const onInput = ({ target: { value: filterValue } }: ChangeEvent<HTMLInputElement>) => {
    // if dataType is number, validation regex for number field
    // first char: [<,>,!,=,digit] | second char: [>,=,digit] | third char can only be digit
    // if it is not number (which means it is a string since we are rendering this component only for these 2),
    // we allow the user to type anything
    const validationRegex = dataType === DataType.NUMBER ? /^([<>]=?|!=|<>|!)?\d*\.?\d*$/ : /.*/;
    if (!validationRegex.test(filterValue)) return;

    setValue(filterValue);
    // if only the operator is added in the filter input, data should not be filtered yet. Original data will be shown
    const operatorOnly = isInValidSearchValue(filterValue);
    if (operatorOnly || isEmpty(filterValue)) {
      onModelChange({
        filterType: 'multi',
        filterModels: [], // Reset filters
      });
      return;
    } else {
      // removing the operators from the filterValue. For ex: !=3 becomes 3.
      const updatedFilterValue = replace(filterValue, /[<>!=]/g, '');

      // Update the model with the new multi filter
      onModelChange({
        filterType: 'multi',
        filterModels: [
          {
            type: getOperator(filterValue, dataType),
            filterType: dataType === DataType.NUMBER ? 'number' : 'text',
            filter: dataType === DataType.NUMBER ? Number(updatedFilterValue) : updatedFilterValue,
          },
        ],
      });
      return;
    }
  };

  const style = {
    width: '100%',
    height: '20px',
    alignSelf: 'center',
  };

  return (
    <Fragment>
      <input className="ag-text-field-input" value={value} style={style} type="text" onInput={onInput} />
    </Fragment>
  );
};
